const nlTranslation = {
  common: {
    close: 'Sluiten',
    flagCaution: 'Gevoelig onderwerp. Controleer dit antwoord goed.',
    flagInfo: 'Goed om te weten.',
    welcome: 'Welkom',
    login: 'Inloggen',
    logout: 'Uitloggen',
    send: 'Versturen',
    stop: 'Stoppen',
    retry: 'Opnieuw proberen',
    loading: 'Laden...',
    error: 'Fout',
    success: 'Succes',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
    typeToFilter: 'Typ om te filteren…',
    save: 'Opslaan',
    language: 'Taal',
    newChat: 'Nieuw gesprek',
    startingNewChat: 'Nieuw gesprek starten...',
    searchMessage: 'Nadenken en relevante informatie analyseren...',
    searchMessageTiming: 'Zoeken door werkinstructies en kennisitems...',
    tryAgain: 'Probeer Opnieuw',
    back: 'Terug',
    enabled: 'Ingeschakeld',
    disabled: 'Uitgeschakeld',
    goBack: 'Ga Terug',
    attachDocument: 'Document bijvoegen',
    aiDisclaimer:
      'Antwoorden worden gegenereerd door AI. Controleer altijd belangrijke informatie via officiële bronnen.',
    copyAnswer: 'Antwoord kopiëren',
    copyMessage: 'Bericht kopiëren',
    copied: 'Gekopieerd!',
    copyToClipboard: 'Naar klembord kopiëren',
    expand: 'Uitklappen',
    minimize: 'Inklappen',
    showMore: 'Toon meer',
    noInternalKnowledge: 'Geen interne kennis gevonden',
    noAdditionalResponse: 'Geen aanvullende reactie',
    swapMessage:
      'We hebben een bedrijfsspecifiek antwoord gevonden. Het algemene antwoord is nog steeds hieronder beschikbaar.',
    toggleShowGeneral: 'Toon algemeen antwoord (ChatGPT)',
    toggleHideGeneral: 'Verberg algemeen antwoord',
    progressExternal: 'Zoeken met ChatGPT…',
    progressInternal: 'Zoeken in bedrijfskennis…',
    internalError: 'Bedrijfskennis momenteel niet beschikbaar.',
    promoteSecondary: 'Gebruik als hoofdantwoord',
    compareAnswers: 'Vergelijk antwoorden zij aan zij',
    switchBack: 'Ga terug',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Interne richtlijnen',
  },
  knowledge_source: {
    general_info: 'Antwoord op basis van AI model',
    internal_guidelines: 'Interne richtlijnen',
    internet_results: 'Internet zoekresultaten',
    searching_internal: 'Zoeken in bedrijfsdata…',
    searching_internet: 'Zoeken op internet…',
    badge_ai: 'AI',
    badge_internal: 'Bedrijfsdata',
    badge_internal_searching: 'Zoeken in bedrijfsdata',
    badge_internet: 'Internet',
    badge_internet_searching: 'Zoeken op internet',
  },
  errors: {
    assistantResponseContentViolation:
      'De reactie van de assistent is in strijd met ons contentbeleid. Probeer het opnieuw of stel je vraag anders.',
    userInputContentViolation:
      'Je verzoek bevat inhoud die in strijd is met ons contentbeleid. Formuleer je vraag anders, alsjeblieft.',
    llmProviderUserInputBlocked:
      'Je bericht is geblokkeerd door het content filter van de AI-provider. Formuleer je vraag anders, alsjeblieft.',
    llmProviderBotResponseBlocked:
      'De AI-reactie is geblokkeerd door het content filter van de provider. Probeer het opnieuw of formuleer je vraag anders.',
    llmProviderApiError: 'We ondervinden problemen met onze AI-service. Probeer het later nog eens.',
    serverError:
      'Er is een onverwachte serverfout opgetreden. Probeer het opnieuw of neem contact op met ondersteuning als het probleem aanhoudt.',
    agentNotFound: 'De assistent die je zoekt bestaat niet of is niet meer beschikbaar.',
    conversationNotFound: 'Het gesprek dat je zoekt bestaat niet of is niet meer beschikbaar.',
    noAccessScopes:
      'Je hebt op dit moment geen toegang tot kennisbronnen. Om toegang aan te vragen, maak een supportticket aan of neem contact op met je IT-beheerder.',
    noAccessScopesWithEmail:
      'Je hebt op dit moment geen toegang tot kennisbronnen. Om toegang aan te vragen, maak een supportticket aan of neem contact op met IT-support via {{email}}.',
    startViolatedPoliciesList: 'De volgende beleidsregels zijn overtreden',
    questionTooLong: {
      title: 'Je vraag is te lang',
      description: 'De maximale lengte is 30.000 tekens.',
    },
    excelNotSupportedYet: {
      title: 'Ondersteuning voor Excel en CSV komt binnenkort!',
      description:
        'We werken aan ondersteuning voor Excel- en CSV-bestanden die binnenkort beschikbaar zijn. Gebruik voorlopig PDF- of Word-bestanden.',
    },
  },
  auth: {
    welcomeTester: 'Welkom collega',
    welcomeMessage: 'Welkom bij {{assistantName}}!',
    loginWithMicrosoft: 'Inloggen met Microsoft',
    loginInstructions: 'Log in met je Microsoft-account om te beginnen.',
    welcomeCompany: 'Welkom bij {{companyName}}!',
    loginWithPassword: 'Inloggen met gebruikersnaam en wachtwoord',
    hidePasswordForm: 'Verbergen',
    login: 'Inloggen',
  },
  chat: {
    placeholder: 'Stel hier je vraag',
    thinking: 'Bezig met denken...',
    anonymousUser: 'Anoniem',
    howToAskGoodQuestion: 'Hoe stel je een goede vraag?',
    askQuestion: 'Stel je vraag',
    exampleQuestions: 'Voorbeeldvragen',
    tryAsking: 'Probeer te vragen:',
    assistant: '{{assistantName}}, je digitale assistent',
    welcomeMessage:
      'Hallo {{name}}! Ik ben {{assistantName}}, je digitale assistent. Ik kan je helpen met vragen over werkinstructies en kennisitems. Wat wil je graag weten?',
    loading: 'Gesprek laden...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    serverError:
      'Er is een onverwachte serverfout opgetreden. Probeer het opnieuw of neem contact op met ondersteuning als het probleem aanhoudt.',
    disclaimerText:
      'AI-gegenereerde antwoorden. Aan deze antwoorden kunnen geen rechten worden ontleend.',
    dropFilesHere: 'Sleep hier bestanden heen om aan de chat toe te voegen',
    addMenu: 'Toevoegen',
    addFiles: 'Bestand toevoegen',
    searchHrKnowledge: 'Doorzoek HR-kennis',
    hrKnowledgeOff: 'HR-kennis uit',
    filteredTo: 'Gefilterd op',
    filters: 'Filters',
    filtersInfo: 'Beperkt de chat tot specifieke filters.',
    unsupportedFileType: 'Bestandstype niet ondersteund',
    uploadingFile: 'Bestand wordt geüpload…',
    uploadLimit: 'Maximale bestandsgrootte: 10 MB',
    fileTooLarge: 'Het bestand mag niet groter zijn dan 10 MB',
    fileTypeNotAllowed: 'Alleen PDF-, Word-, Excel-, PowerPoint- (PPTX), CSV- en TXT-bestanden zijn toegestaan',
    documentUploaded: 'Document succesvol geüpload',
    documentUploadFailed: 'Uploaden van document mislukt',
    documentRemoved: 'Document verwijderd',
    documentRemoveFailed: 'Verwijderen van document mislukt',
  },
  internetSearch: {
    badgeLabel: 'Internet zoeken aan',
    badgeTooltip: 'Deze assistent kan internet gebruiken om te zoeken',
    inlineWarning:
      'Let op: Deel geen bedrijfsgevoelige of persoonlijke gegevens. Invoer bij internetzoeken kan door Microsoft worden gebruikt voor training.',
    dismiss: 'Afwijzen',
    modalTitle: 'Wees voorzichtig met gevoelige gegevens',
    modalBody:
      'Deze assistent gebruikt internetzoekopdrachten. Deel geen bedrijfsgevoelige of persoonlijke informatie. Invoer kan worden verwerkt door Microsoft en gebruikt worden om modellen te trainen. Deel alleen wat noodzakelijk is en houd je aan het beleid.',
    gotIt: 'Begrepen',
  },
  agentChat: {
    placeholder: 'Typ je vraag voor de agent...',
    welcomeMessage: 'Hallo, ik ben je AI-agent. Hoe kan ik je helpen?',
    privilegedWelcomeMessage: 'Hallo {{userName}}! {{description}}',
    startPrompt: 'Stel een vraag om te beginnen',
  },
  profile: {
    settings: 'Instellingen',
    selectLanguage: 'Selecteer je taal',
    appearance: 'Uiterlijk',
    darkMode: 'Donkere modus',
    languageChanged: 'Taal gewijzigd',
    noEmailAvailable: 'Geen e-mail beschikbaar',
    general: 'Algemeen',
    models: 'Modellen',
    noModelsAvailable: 'Geen modellen beschikbaar',
    modelSettings: 'Modelinstellingen',
    savingSettings: 'Opslaan...',
    settingsUpdateFailed: 'Modelinstellingen opslaan mislukt. Probeer het opnieuw.',
  },
  sidebar: {
    conversations: 'Geschiedenis',
    assistants: 'Assistenten',
    userGuide: 'Gebruikersuitleg',
    chatHistory: 'Gespreksgeschiedenis',
    today: 'Vandaag',
    thisWeek: 'Deze week',
    lastWeek: 'Vorige week',
    earlier: 'Eerder',
    conversation: 'Gesprek',
    noAssistantsAvailable: 'Geen assistenten beschikbaar',
    noContent: 'Geen inhoud',
    noPreviousConversations: 'Geen eerdere gesprekken gevonden',
    searchConversations: 'Zoek in geschiedenis...',
    noSearchResults: 'Geen geschiedenis die overeenkomt met je zoekopdracht',
    favorites: 'Favorieten',
    noFavorites: 'Geen favorieten',
    addFavoritesHint: 'Ga naar de bibliotheek om assistenten aan je favorieten toe te voegen.',
    loadingPrivilegedAgents: 'Assistenten laden...',
    rename: 'Hernoemen',
    conversationActions: 'Gesprekacties',
    renameConversationError: 'Hernoemen van het gesprek mislukt',
    delete: 'Verwijderen',
    deleteConversation: 'Gesprek verwijderen',
    deleteConversationConfirm: 'Weet je zeker dat je het gesprek wilt verwijderen: {{title}}?',
    deleteConversationError: 'Verwijderen van het gesprek mislukt',
  },
  feedback: {
    likeAnswer: 'Antwoord leuk vinden',
    dislikeAnswer: 'Antwoord niet leuk vinden',
    feedbackSent: 'Je feedback is verzonden! ✅',
    provideFeedback: 'Geef feedback op de vraag',
    enterFeedback: 'Vul hier je feedback in',
    send: 'Verzenden',
    assistantFallback: 'AI-assistent',
    downvoteDisclaimer:
      'Als je op verzenden drukt, worden je laatste twee berichten anoniem gedeeld voor analyse om {{assistant}} te helpen verbeteren.',
    reasons: {
      incorrect: 'Antwoord klopt niet',
      sourceIncorrect: 'Bron klopt niet',
      other: 'Anders...',
    },
  },
  // Generic information pop-out — client-agnostic.
  // Texts are feature-flag driven and use {{companyName}} for the company name.
  informationModal: {
    title: 'Over de {{companyName}} assistent',
    intro:
      'Welkom bij de {{companyName}} assistent. Hieronder lees je waar de assistent je mee kan helpen en hoe je er het beste uithaalt.',
    capabilitiesTitle: 'Waar kan de assistent je mee helpen?',
    activeVanillaChat:
      'De assistent kan vragen beantwoorden zoals je die aan ChatGPT zou stellen.',
    activeVanillaInactiveWebSearch:
      'De assistent heeft veel algemene kennis, maar weet niets van actualiteiten zoals het laatste nieuws.',
    activeInternalSearch:
      'De assistent kan vragen beantwoorden op basis van een specifieke selectie aan interne informatiebronnen.',
    activeInternetSearch:
      'De assistent heeft toegang tot het internet om vragen over de actualiteit te beantwoorden.',
    activeInternetSearchPrivacyWarning:
      'Let op: vragen en antwoorden via internetzoekopdrachten zijn, net als bij regulier internetgebruik, niet volledig privé. Deel geen vertrouwelijke bedrijfsinformatie wanneer je internetzoeken gebruikt.',
    activeDocumentUpload:
      'Je kunt documenten uploaden en daar met de assistent over praten, bijvoorbeeld om ze samen te vatten of actiepunten op te halen.',
    activeAgents:
      'Je kunt specifieke <1>assistenten</1> selecteren om mee te praten. Elke assistent heeft eigen instructies en helpt je daardoor beter met specifieke taken.',
    activeModelSelection:
      'In het tekstinvoerveld kies je welk AI-model je vraag beantwoordt. Op de <1>modelinstellingen-pagina</1> pas je per model de instellingen aan om te bepalen hoe het op je vragen reageert.',
    usageTipsTitle: 'Zo haal je het beste uit de assistent',
    askClearQuestions:
      'Stel een duidelijke vraag in volzinnen. Losse trefwoorden leveren vaak een matig antwoord op; een volledige zin geeft de assistent de context om je goed te helpen.',
    conversationHistory:
      'Binnen één gesprek onthoudt de assistent wat je eerder hebt gezegd, zodat je vervolgvragen kunt stellen. Hij begrijpt echter niet wat je bedoelt als je verwijst naar informatie uit andere gesprekken.',
    startNewConversation:
      'Begin een nieuw gesprek zodra je over een ander onderwerp wilt praten, dan blijven antwoorden scherp.',
    bewareAssistantsNotAgents:
      'Let op: dit is een AI-assistent, geen AI-agent. Hij helpt je bij losse taken als je daarom vraagt, bijvoorbeeld een e-mail samenvatten, maar onderneemt niet zelfstandig vervolgacties zoals e-mails versturen.',
    feedback:
      'Gebruik de duimpjes onder een antwoord om feedback te geven. Daarmee help je de assistent slimmer te maken.',
    dataVisibilityNoticeTitle: 'Kennisgeving over gegevenszichtbaarheid',
    bewareDoNotSharePersonalInformation: 'Let op: deel geen persoonlijke informatie.',
    supportTitle: 'Hulp nodig?',
  },
  library: {
    title: 'Assistenten Bibliotheek',
    subtitle:
      'Ontdek en maak aangepaste versies van assistenten die instructies, extra kennis en elke combinatie van vaardigheden combineren.',
    searchPlaceholder: 'Zoek assistenten...',
    createAgent: 'Assistent Maken',
    createFirstAgent: 'Maak je eerste assistent',
    noAgents: 'Geen assistenten beschikbaar',
    noSearchResults: 'Geen assistenten die overeenkomen met je zoekopdracht',
    noDescription: 'Geen beschrijving beschikbaar',
    active: 'Actief',
    library: 'Bibliotheek',
    of: 'van',
    assistants: 'assistenten',
    clearFilters: 'Filters wissen',
    filtersCleared: 'Filters gewist',
    all: 'Alle',
    favorites: 'Favorieten',
    normal: 'Normaal',
    privileged: 'Geprivilegieerd',
    noTags: 'Geen tags',
    agentSelected: 'Assistent geselecteerd',
    isNowActive: 'is nu actief',
    select: 'Selecteren',
    addToFavorites: 'Toevoegen aan favorieten',
    removeFromFavorites: 'Verwijderen uit favorieten',
    moreTags: 'meer tags',
    editAgent: 'Assistent bewerken',
  },
  createAgent: {
    title: 'Nieuwe Assistent',
    subtitle: 'Maak een nieuwe AI-assistent om je team te helpen',
    saving: 'Opslaan...',
    saveAgent: 'Assistent Opslaan',
    basicInfo: 'Basisinformatie',
    classification: 'Classificatie',
    tagsAndCustomization: 'Tags & Aanpassingen',
    icon: 'Pictogram',
    name: 'Naam',
    namePlaceholder: 'Geef de assistent een naam',
    description: 'Beschrijving',
    descriptionPlaceholder: 'Beschrijf wat de assistent kan doen',
    department: 'Afdeling',
    selectDepartment: 'Selecteer een afdeling',
    jobCategory: 'Functiecategorie',
    selectJobCategory: 'Selecteer een functiecategorie',
    tags: 'Tags',
    optional: 'optioneel',
    addNewTag: 'Voeg een nieuwe tag toe',
    add: 'Toevoegen',
    existingTags: 'Bestaande tags',
    promptTemplate: 'Promptsjabloon',
    promptTemplatePlaceholder:
      'Definieer hoe de assistent moet antwoorden... (bijvoorbeeld: Je bent een helpdesk-assistent die vriendelijk en professioneel antwoord geeft op vragen over...)',
    fillAllRequiredFields: 'Vul alstublieft alle verplichte velden in',
    agentCreated: 'Assistent gemaakt',
    createdSuccessfully: 'is succesvol gemaakt',
    creationError: 'Fout bij maken',
    creationErrorDescription: 'Er is een fout opgetreden bij het maken van de assistent',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    unsavedChangesMessage:
      'Je hebt wijzigingen aangebracht die nog niet zijn opgeslagen. Weet je zeker dat je terug wilt gaan?',
    manageJobCategories: 'Beheer functiecategorieën voor deze afdeling',
    instructions: 'Instructies',
    instructionsDescription: 'Definieer hoe je assistent zich moet gedragen en op gebruikers moet reageren',
    instructionsLabel: 'Instructies',
    instructionsPlaceholder: 'Je bent een behulpzame assistent die...',
    instructionsHelperText: 'Wees specifiek over de rol van de assistent, toon en hoe deze gebruikers kan helpen',
    instructionsMinLength: 'Instructies moeten minimaal 20 tekens zijn',
    tools: 'Gereedschappen',
    searchTool: 'Zoekgereedschap',
    toolsFileSearch: 'Bestandenzoeken',
    toolsInternetSearch: 'Internetzoeken',
    tracing: 'Tracing',
    tracingHelp: 'Bepaal of en hoe het interne gedrag van deze agent wordt gelogd voor diagnostische doeleinden. Overschrijft tool-gebaseerde instellingen',
    tracingAlways: 'Aan',
    tracingNever: 'Uit',
    tracingToolBased: 'Op basis van tools',
    featureRequest: 'Verzoek om functie',
    deleteAssistant: 'Assistent Verwijderen',
    tagsHelp: 'Tags helpen bij het organiseren en categoriseren van je assistent',
    exampleQuestions: 'Voorbeeldvragen',
    exampleQuestionsHelp: 'Voeg voorbeeldvragen toe die gebruikers kunnen aanklikken om een gesprek te starten',
  },
  editAgent: {
    title: 'Assistent Bewerken',
    subtitle: 'Wijzig de instellingen en gedrag van je AI-assistent',
    updateAgent: 'Assistent Bijwerken',
    deleteAgent: 'Assistent Verwijderen',
    updating: 'Bijwerken...',
    deleting: 'Verwijderen...',
    agentUpdated: 'Assistent Bijgewerkt',
    updatedSuccessfully: 'is succesvol bijgewerkt',
    updateError: 'Updatefout',
    updateErrorDescription: 'Er is een fout opgetreden bij het bijwerken van de assistent. Probeer het opnieuw.',
    agentDeleted: 'Assistent Verwijderd',
    deletedSuccessfully: 'is succesvol verwijderd',
    deleteError: 'Verwijderingsfout',
    deleteErrorDescription: 'Er is een fout opgetreden bij het verwijderen van de assistent. Probeer het opnieuw.',
    deleteConfirmTitle: 'Assistent Verwijderen',
    deleteConfirmMessage:
      'Weet je zeker dat je deze assistent wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    confirmDelete: 'Ja, Verwijder',
    loadingAgent: 'Assistentdetails laden...',
    failedToLoad: 'Kon assistentdetails niet laden',
  },
  jobCategory: {
    addNew: 'Categorie Toevoegen',
    name: 'Naam',
    nameRequired: 'Categorienaam is vereist',
    enterName: 'Voer categorienaam in...',
    create: 'Maken',
    edit: 'Bewerken',
    update: 'Bijwerken',
    delete: 'Verwijderen',
    created: 'Categorie Gemaakt',
    createdSuccessfully: 'is succesvol gemaakt',
    updated: 'Categorie Bijgewerkt',
    updatedSuccessfully: 'is succesvol bijgewerkt',
    deleted: 'Categorie Verwijderd',
    deletedSuccessfully: 'is succesvol verwijderd',
    creationError: 'Fout bij maken',
    creationErrorDescription: 'Er is een fout opgetreden bij het maken van de categorie',
    updateError: 'Updatefout',
    updateErrorDescription: 'Er is een fout opgetreden bij het bijwerken van de categorie',
    deletionError: 'Verwijderingsfout',
    deletionErrorDescription: 'Er is een fout opgetreden bij het verwijderen van de categorie',
    deleteError: 'Verwijderingsfout',
    deleteErrorDescription: 'Er is een fout opgetreden bij het verwijderen van de categorie',
    deleteConfirmTitle: 'Categorie Verwijderen',
    deleteConfirmMessage: 'Weet je zeker dat je "{{name}}" wilt verwijderen?',
    deleteWarning: 'Deze actie kan niet ongedaan worden gemaakt en kan invloed hebben op bestaande agenten.',
    warning: 'Waarschuwing',
    agentsWillLoseCategory: 'agenten zullen hun categoriebinding verliezen',
  },
  languageNames: {
    en: 'Engels',
    nl: 'Nederlands',
    de: 'Duits',
    fr: 'Frans',
    it: 'Italiaans',
    pl: 'Pools',
    hu: 'Hongaars',
    id: 'Indonesisch',
  },
  knowledgeSourceSelector: {
    title: 'Kennisbronnen',
    tooltip: 'Kies welke kennisbronnen worden doorzocht',
    all: 'Alle',
  },
  countries: {
    nl: 'Nederland',
    us: 'Amerika',
    hu: 'Hongarije',
    id: 'Indonesië',
  },
  iconSelector: {
    chooseIcon: 'Kies een pictogram',
  },
  models: {
    introHeading: 'Modelinstellingen',
    introBody: 'Op deze pagina stel je in hoe ieder model zich gedraagt. Welk model er voor een gesprek wordt gebruikt kies je niet hier, maar in de chat zelf bij het invoerveld waar je je vraag stelt.',
    noConfigurableParameters: 'Geen instellingen voor dit model',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'AI assistent voor bedrijfskennis van AHV International.',
}

export default { ...nlTranslation, ...clientDefaults }
